<template>
  <zul-modal id="subscription-modal" class="is-medium" ref="modal" title="Assinar alertas" :primary="'Contratar'" @primary="next()" @secondary="cancel()">

    <div v-if="showLoader">
      <div class="loading">
        Carregando...
      </div>
    </div>

    <div v-else-if="step === 1">
      <span class="icon is-bell"></span>
      <h1 class="title text-center">{{ subscription.title }}</h1>
      <ul>
        <li v-for="item in subscription.benefits" :key="item">{{ item }}</li>
      </ul>

      <p class="price"><span>R$ {{ subscription.monthlyValue | currency('', 2,  { decimalSeparator:',' }) }}/mês</span> &nbsp;&nbsp;&nbsp;&nbsp;
      R$ <strong>{{ subscription.yearlyValue | currency('', 2,  { decimalSeparator:',' }) }}</strong>/ano</p>
    </div>

    <div v-else-if="step === 2">
      <h1 class="title is-tiny text-center">Selecione o veículo</h1>
      <p class="subtitle text-center">Escolha qual veículo deseja monitorar:</p>
      
      <div v-for="vehicle in vehicles" :key="vehicle.id" @click="selectVehicle(vehicle)" class="vehicle-button">
        <span class="plate">{{ vehicle.registrationPlate }}</span>
        <span class="name">{{ vehicle.alias }}</span>

        <span class="extra">
          <span :class="{ bullet: true, selected: selectedVehicles.indexOf(vehicle) !== -1 }"></span>
        </span>
      </div>

      <p class="notes">Ao utilizar o serviço você declara ter lido e concordado com os <a href="#" @click="showTerms()">termos de uso</a> do serviço</p>

      <p class="price" v-if="this.selectedVehicles.length">
        <span>R$ {{ subscription.monthlyValue *  this.selectedVehicles.length | currency('', 2,  { decimalSeparator:',' }) }}/mês</span> &nbsp;&nbsp;&nbsp;&nbsp;
        R$ <strong>{{ subscription.yearlyValue * this.selectedVehicles.length | currency('', 2,  { decimalSeparator:',' }) }}</strong>/ano</p>
      <p class="price" v-else><span>R$ {{ subscription.monthlyValue | currency('', 2,  { decimalSeparator:',' }) }}/mês</span> &nbsp;&nbsp;&nbsp;&nbsp;
        R$ <strong>{{ subscription.yearlyValue | currency('', 2,  { decimalSeparator:',' }) }}</strong>/ano</p>
    </div>

    <div v-else-if="step === 3">
      <h1 class="title is-tiny text-center">Forma de pagamento</h1>
      <p class="subtitle text-center">Escolha a forma de pagamento</p>

      <zul-button class="is-large" v-for="p in paymentTypes" :key="p.name" :data="{}" @click="setPaymentType(p)" :disabled="!p.enabled">
        <span slot="icon" :class="{ 'icon': true, 'is-card': p.type == 'CREDIT', 'is-bankslip': p.type == 'BANKSLIP'}"></span>
        {{ p.name | lowercase | capitalize }}
        <span slot="sub" v-if="p.redeem" class="is-masterpass">{{ p.redeem.discount }} <br><img src="../../public/img/cards.png" width="90px" alt="Aceita cartões Mastercard, Visa, Amex e Dinners"></span>
      </zul-button>
    </div>

    <div v-else-if="step === 4">
      <h1 class="title is-tiny text-center">Forma de pagamento</h1>
      <p class="subtitle text-center">Em qual cartão deseja assinar?</p>

      <p v-if="response">{{ response.message }}</p>

      <zul-button class="is-large" :data="{}" v-for="p in paymentMethods" :key="p.id" @click="setPaymentMethod(p)">
          **** **** **** {{ p.lastDigits }}
        <span slot="sub"><img :src="p.processor.image['@2x']" width="60"></span>
      </zul-button>
      <a class="button is-text is-medium is-center" @click="addCreditCard()">Cadastrar novo cartão de crédito</a>
    </div>

    <div v-else-if="step === 5">
      <p v-html="paymentMethod.message.body"></p>
      <br>

      <div class="summary">
        <zul-button class="is-view is-large">
          **** **** **** {{ paymentMethod.lastDigits }}
          <span slot="sub"><img :src="paymentMethod.processor.image['@2x']" width="60"></span>
        </zul-button>
        <div v-if="paymentMethod.requiresTfa">
          <label v-html="paymentMethod.tfaQuestion"></label>
          <zul-mega-input name="tfa" v-validate="'required'" v-model="tfa" @input="validate('tfa')"></zul-mega-input>
          <p v-if="invalidTFA" class="is-note">Digitos inválidos, verifique e tente novamente.</p>
        </div>
        
      </div>
    </div> 

    <div v-else>
      <div v-if="success" class="success">
        <div class="text-center">
          <span class="icon is-success"></span>
          <p><strong>Parabéns!</strong> Você contratou com<br> sucesso o alerta.</p>
        </div>

      </div>
      <div v-else class="error">
        <span class="icon is-error"></span>
        <p>Não foi possível completar sua solicitação. Tente novamente mais tarde.</p>
      </div>
    </div>
  </zul-modal>
</template>

<script>
import ZulButton from '../components/Button.vue'
import jsencrypt from 'jsencrypt'
import RSA from '../helpers/rsa.js'

export default {
  props: {},
  data () {
    return {
      showLoader: true,
      vehicles: this.$auth.user().vehicles,
      selectedVehicles: [],
      subscription: null,
      paymentTypes: null,
      paymentType: null,
      paymentMethods: null,
      success: false,
      response: null,
      step: 1
    }
  },
  mounted () {
    this.$root.$on('open-subscription-modal', (reset) => {
      if (reset) {
        this.$refs.modal.setProps({labels: { primary: false }})
        Object.assign(this.$data, this.$options.data.apply(this))

        this.TAX.get('subscription').then(res => {
          this.$refs.modal.setProps({labels: { primary: 'Contratar' }})
          this.subscription = res.data
          this.showLoader = false
        })
      } else {
        this.showLoader = false  
      }
      this.$refs.modal.open()
    })
    this.$root.$on('close-subscription-modal', () => {
      this.close()
    })
    this.$root.$on('reset-subscription-modal', this.reset)
  },
  destroyed () {
    this.$root.$off('open-subscription-modal')
    this.$root.$off('close-subscription-modal')
    this.$root.$off('reset-subscription-modal')
  },
  methods: {
    next () {
      this.step++
      this.$refs.modal.setProps({ labels: { primary: false } })

      if (this.step === 2) {
        this.$refs.modal.setProps({ disabled: true, labels: { primary: 'Avançar' } })
      } else if (this.step === 3) {

       this.showLoader = true

        this.$http.get(`/order/paymenttypes?action=TAXES&installment=1&amount=${this.subscription.yearlyValue}`)
          .then(res => {
            this.showLoader = false

            this.$refs.modal.setProps({labels: { primary: false }})
            this.paymentTypes = res.data.items.filter(o => o.type === 'BANKSLIP' || ( o.type === 'CREDIT' && !o.wallet ) || ( o.type === 'CREDIT' && o.wallet === 'MASTERPASS' ) )
            //this.message = res.data.message
          })
      } else if (this.step === 6) {
        this.response = null
        this.$refs.modal.startLoading()
        this.invalidTFA = false

        this.data = {}
        this.data.planId = this.subscription.planId
        this.data.registrationPlate = this.selectedVehicles[0].registrationPlate
      

        // set paymentMethodId
        this.data.paymentMethodId = this.paymentMethod.id

        if (this.paymentMethod.requiresTfa) {
          this.data.tfa = this.tfa

          let toEncrypt = JSON.stringify(parseInt(this.tfa) );
          let encrypted = '';

          let j = new jsencrypt({
            default_key_size: 512
          });
          j.setPublicKey(this.$auth.user().publicKey);

          let mod = j.getKey().n.toRadix(16);
          let rsa = new RSA(mod);

          encrypted = rsa.encrypt(toEncrypt);

          if (encrypted !== this.$auth.user().tfaHash) {
            this.invalidTFA = true
            this.$refs.modal.stopLoading()
            return
          }
        }

        if (this.paymentMethod.redeem) {
          this.data.redeemCode = this.paymentMethod.redeem.code
        }

        //const paymentRejected = this.subscription.status === 'PAYMENT_REJECTED'
        //const method = paymentRejected ? 'put' : 'post'
        const method = 'post'
        //const uri =    paymentRejected ? `/insurance/policy/${this.planDetail.plan.policyId}` : '/insurance/policy'
        const uri = '/subscription'

        this.TAX[method](uri + '?' + Object.keys(this.data).map(key => key + '=' + this.data[key]).join('&')).then(res => {
          let interval = window.setInterval(() => {
            this.TAX.get(`/subscription/${res.data.id}`).then(res => {

              if (res.data.status !== 'PROCESSING') {
                clearInterval(interval)
                delete this.data

                if (res.data.status === 'PAYMENT_REJECTED') {
                  this.planDetail.plan.status = res.data.status
                  this.planDetail.plan.policyId = res.data.id
                  this.response = {message: 'Houve um erro ao processar o seu pagamento, tente novamente.'}
                  this.$refs.modal.setProps({labels: { primary: 'Confirmar' }})
                  this.$refs.modal.stopLoading()
                  this.step = 8
                } else {
                  this.success = true
                  this.$refs.modal.setProps({type: 'neutral', labels: { primary: 'Fechar' }})
                  this.$refs.modal.stopLoading()
                  this.step++
                }
              }
            })
          }, 2000)
        })

      } else if (this.step >= 7 || this.step === 0) {
        this.$refs.modal.close()
      }
      
    },

    selectVehicle (vehicle) {
      this.selectedVehicles = [vehicle]
      this.$refs.modal.setProps({ disabled: false })

      /*let index = this.selectedVehicles.indexOf(id);

      if (index === -1) {
          this.selectedVehicles.push(id);
      } else {
          this.selectedVehicles.splice(index, 1);
      }

      if (this.selectedVehicles.length === 0) {
        this.$refs.modal.setProps({ labels: { primary: false } })
      } else {
        this.$refs.modal.setProps({ labels: { primary: 'Avançar' } })
      }*/
    },

    showTerms () {
      this.close()

      this.$root.$off('terms-modal-end')
      this.$root.$on('terms-modal-end', () => {
        this.$refs.modal.open()
      })

      this.$root.$emit('open-terms-modal', 10)
    },


    setPaymentType (type) {
      this.paymentType = type
      
      if (type.type === 'CREDIT' && type.wallet === 'MASTERPASS') {
        if (type.connected) {
          this.getMasterpassPayments()
        } else {
          this.masterpassConnect()
        }        
      } else if (type.type === 'CREDIT') {
        this.paymentMethods = this.$auth.user().paymentMethods
        this.step++
      }
    },

    setPaymentMethod (card) {
      this.showLoader = true
      this.paymentMethod = card

      if (!this.paymentMethod.id) {
        const formData = new FormData()
        formData.append('token', this.paymentMethod.token)
        formData.append('gateway', 'MASTERPASS')
        formData.append('allowOverride', true)
        this.$http.post('/user/payment', formData).then(res => {
          this.paymentMethod = res.data
        })
      }

      const timer = setInterval(() => {
        if (this.paymentMethod.id) {
          clearInterval(timer)

          this.$http.get(`/user/payment/${this.paymentMethod.id}?category=TAXES&amount=${this.subscription.yearlyValue}0&installment=1`).then(res => {
            this.paymentMethod = res.data
            this.showLoader = false
            this.step++
            this.$refs.modal.setProps({ labels: { primary: 'Confirmar' } })
          })
        }
      }, 2000)
    },




    validate() {
      this.$validator.validateAll().then( (/* result */) => {
      })
    },

    close () {
      this.$refs.modal.close()
    }
  },
  components: {
    ZulButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/sass/variables';
  .icon.is-bell {
    margin: 30px auto 30px;
    background-image: $bellIcon;
    width: 135px;
    height: 135px;
    opacity: 1;
  }

  .title {
    margin-bottom: 35px !important;

    &.is-tiny {
      font-size: 24px;
      margin-bottom: 14px !important;
    }
  }

  .subtitle {
    font-size: 18px;
    color: #989898 !important;
    margin-top: 10px !important;
  }

  .text-center {
    text-align: center;
  }

  .notes {
    font-size: 12px;
    text-align: center;
    color: #989898 !important;
    margin-top: 16px;
  }

  ul {
    list-style: none;
    margin-left: 25px;
  }

  ul li::before {
    content: "\2022";
    color: #09b6f3;
    font-weight: bold;
    display: inline-block;
    width: 1.5em;
    margin-left: -1.5em;
  }

  .price {
    color: #989898 !important;
    margin-top: 30px;
    text-align: center;
    font-size: 22px;

    strong {
      color: #fff;
    }
    span {
      color: #989898;
    }
  }

  .vehicle-button {
    background: #3E3E3E;
    font-weight: bold;
    padding: 12px 24px 18px;
    border-left: 2px $primarySAO solid;
    position: relative;
    margin-bottom: 2px;
    cursor: pointer;

    .plate {
      font-size: 25px;
    }

    .name {
      display: block;
      font-size: 12px;
      color: #989898;
      text-transform: uppercase;
    }

    .extra {
      position: absolute;
      top: 32px;
      right: 30px;
    }

    .bullet {
      width: 20px;
      height: 20px;
      display: block;

      box-shadow: 0px 0px 0px 2px #989898;
      border: 4px #3E3E3E solid;
      background: transparent;
      border-radius: 50px;
      transition: .2s all;

      &.selected {
        background: $primarySAO;
        box-shadow: 0px 0px 0px 2px $primarySAO;
      }
    }

  }

  .loading {
    background: url('../assets/loading.svg') no-repeat center 35%;
    background-size: 100px;
    text-align: center;
    padding: 7rem 0 0;
    font-size: $size-7;
    opacity: .5;
    margin-right: 0;
  }

</style>